import { useContext } from 'react'
import { I18nContext } from '../../context/I18nProvider'
//Libs
import Translate from '../../i18n/Translate'
import { useQuery } from 'react-query'
//Components
import ItineraryCard from '../../components/Itinerary/ItineraryCard'
import { SpinnerEllipsis } from '../../components/Spinners'
//Intersection
import { useInView } from 'react-intersection-observer'
import Api from '../../api'

const SimilarPackages = ({ related }) => {
    const { language } = useContext(I18nContext)

    const { data: itineraries, status } = useQuery(['related-itineraries', { ids: related }, language], () =>
        Api.itineraries.relateds(related, language)
    )

    const [packages, inView] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    })

    //Mientras carga
    if (status === 'loading') {
        return <SpinnerEllipsis />
    }
    //Si hubo error al hacer el fetch
    if (status === 'error') {
        return null
    }
    //Si no se encontro itinerario con ese ID
    if (!itineraries) {
        return null
    }

    return (
        <section
            className={`incoming-itinerary-detail__packages animate slide-up ${inView ? 'in-view' : ''}`}
            ref={packages}
        >
            <h2 className="title">
                <Translate langkey="itinerary_detail.packages.title" />
            </h2>

            <div className="itineraries-list">
                {itineraries.map((itinerary) => {
                    return <ItineraryCard itinerary={itinerary} key={itinerary.id} />
                })}
            </div>
        </section>
    )
}
export default SimilarPackages
